import { get_cart_products } from './cardReducer';
import { normalizeStoreName } from '../../utils/storeUtils';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

export const place_order = createAsyncThunk(
    'order/place_order',
    async ({ quoteToken, shippingInfo, checkoutKey, navigate, fromStore, products }, { rejectWithValue, dispatch, getState }) => {
        try {
            const fingerprint = JSON.stringify({ shippingInfo, fromStore, lines: (products || []).flatMap(g => g.products.map(p => [p.productInfo._id, p.optionId || p.productInfo.selectedOptionId || "", p.quantity])) });
            let requestBody = { quoteToken, shippingInfo, checkoutKey, storeSlug: fromStore };
            try {
                const pending = JSON.parse(sessionStorage.getItem('pending-direct-checkout') || 'null');
                if (pending?.fingerprint === fingerprint) requestBody = pending.requestBody;
                sessionStorage.setItem('pending-direct-checkout', JSON.stringify({ fingerprint, requestBody }));
            } catch (_) {}
            const { data } = await api.post('/payment/direct/orders', requestBody);
            sessionStorage.removeItem('pending-direct-checkout');
            if (data.guestToken) localStorage.setItem(`order-access:${data.orderId}`, data.guestToken);
            const purchasedIds = new Set((products || []).flatMap(group => group.products.map(p => `${p.productInfo._id}:${p.optionId || p.productInfo.selectedOptionId || ""}`)));
            const storageKey = fromStore ? `guestCart_${normalizeStoreName(fromStore)}` : 'guestCart';
            try { const cart = JSON.parse(localStorage.getItem(storageKey) || '[]'); localStorage.setItem(storageKey, JSON.stringify(cart.filter(p => !purchasedIds.has(`${p.productInfo?._id}:${p.optionId || p.productInfo?.selectedOptionId || ""}`)))); } catch (_) {}
            dispatch(get_cart_products({ userId: getState().auth?.userInfo?.id, storeName: fromStore }));
            const paymentPath = fromStore ? `/${fromStore}/payment` : '/payment';
            navigate(`${paymentPath}?orderId=${data.orderId}`);
            return data;
        } catch (error) { if (error.response?.status >= 400 && error.response?.status < 500) sessionStorage.removeItem('pending-direct-checkout'); return rejectWithValue(error.response?.data?.error || 'Unable to place this order. Please retry.'); }
    }
);

export const get_orders = createAsyncThunk(
    'order/get_orders',
    async ({ customerId, status }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/home/customer/gat-orders/${customerId}/${status}`);
            return fulfillWithValue(data);
        } catch (error) {
            console.log(error.response);
        }
    }
);

export const get_order = createAsyncThunk(
    'order/get_order',
    async (orderId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/home/customer/gat-order/${orderId}`);
            return fulfillWithValue(data);
        } catch (error) {
            console.log(error.response);
            return rejectWithValue(error.response.data);
        }
    }
);

export const orderReducer = createSlice({
    name: 'order',
    initialState: {
        myOrders: [],
        sellerOrders: [],
        errorMessage: '',
        successMessage: '',
        myOrder: {}
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = '';
            state.successMessage = '';
        }
    },
    extraReducers: {
        [get_orders.fulfilled]: (state, { payload }) => {
            state.myOrders = payload?.orders || [];
        },
        [get_order.fulfilled]: (state, { payload }) => {
            state.myOrder = payload.order;
            state.sellerOrders = payload.sellerOrders;
        }
    }
});

export const { messageClear } = orderReducer.actions;
export default orderReducer.reducer;